import onGetPatients from './onGetPatients';
import onGetMorePatients from './onGetMorePatients';
import onActivatePatient from './onActivatePatient';
import onUpdatedBloodPressureReading from './onUpdatedBloodPressureReading';

export default {
  onGetPatients,
  onGetMorePatients,
  onActivatePatient,
  onUpdatedBloodPressureReading,
};
